import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { SearchFieldModule } from '@sc/portal.fe.lib.ui-core-components';

@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule,
    SearchFieldModule
  ],
  exports: [HeaderComponent],
})
export class HeaderModule { }
